// extracted by mini-css-extract-plugin
module.exports = {"layout-wrapper":"MyAccount_layout-wrapper__x6a8k","background":"MyAccount_background__bwHUY","my-account-container":"MyAccount_my-account-container__TX8fl"};